export default "__VITE_ASSET__Cr6uw8Is__"